import React, { useEffect, useState } from "react";
import CustomerInfo from "../CustomerInfoHoliday";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import { useRouter } from "next/router";
import CancelIcon from "@mui/icons-material/Cancel";
import { staycationSaveBooking } from "../../../redux/slices/staycation";
import { getBookingOrEnquiry } from "../../../redux/slices/common";
import calculateDiscount from "../../Discounts/discount";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const Index = ({ setValues, values, searchCountryCodeValue, setSearchCountryCodeValue, setFormLoading, formLoading }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const router = useRouter();
  const dispatch = useDispatch();
  const [openAdd2, setOpenAdd2] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [bookingLoader, setBookingLoader] = useState(false);
  const [getDetails, setGetDetails] = useState(undefined);
  const [validate, setValidate] = useState(false);
  const [isBookNow, setIsBookNow] = useState(false);
  const [isBookingFlow, setIsBookingFlow] = useState(null);
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    specialRequest: "",
  });
  const {
    roomId,
    country,
    pricingId,
    packageId,
    hotelId,
    packageName,
    packageImage,
    rating,
    reviews,
    cityName,
    city,
    checkIn,
    checkOut,
    checkInTime,
    checkOutTime,
    adult,
    child,
    roomCount,
    room,
    nights,
    vendorId, price,
    currency,
    vat,
    originalPrice,
    extraCharge,
    additionalCounters,
    defaultNights,
    defaultPrice
  } = router.query;
  const { staycationBookingRes } = useSelector((state) => state.staycation);
  const { bookingOrEnquiryRes } = useSelector((state) => state.common);
  const [totalPay, setTotalPay] = useState(price);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [rooms, setRooms] = useState([]);
  const [formData, setFormData] = useState({
    customerDetails: [],
  });
  const [guestDatas, setGuestDatas] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const { customerDetails } = formData;

  useEffect(() => {
    dispatch(getBookingOrEnquiry());
  }, [dispatch]);

  useEffect(() => {
    if (bookingOrEnquiryRes) {
      setIsBookingFlow(bookingOrEnquiryRes?.staycationBookingFlow ? bookingOrEnquiryRes?.staycationBookingFlow : 1); // or use any other property as needed
    }
  }, [bookingOrEnquiryRes]);

  useEffect(() => {
    if (typeof additionalCounters === 'string') {
      try {
        const parsedRooms = JSON.parse(additionalCounters);
        if (Array.isArray(parsedRooms) && parsedRooms.length > 0) {
          setRooms(parsedRooms);
        }
      } catch (error) {
        console.error("Error parsing PaxRoomss:", error);
      }
    }
  }, [additionalCounters]);

  function createArrayOfObjects(rooms) {
    // Create an array to store the objects
    const arrayOfObjects = [];

    // Loop through each room in paxRooms
    rooms.forEach((room, index) => {
      const { adults, children, childrenAges, Rooms } = room;

      // Create an object for the current room
      const obj = {
        roomTitle: `Room ${index + 1}`,
        customerNames: []
      };

      // Add adults to the current room
      for (let i = 0; i < adults; i++) {
        obj.customerNames.push({ type: 'adult', firstName: '', lastName: '', title: 'Mr' });
      }

      // Add children to the current room
      for (let i = 0; i < children; i++) {
        // If childrenAges array exists and has values, use them
        const age = childrenAges && childrenAges[i] ? childrenAges[i] : 0;
        obj.customerNames.push({ type: 'child', age, firstName: '', lastName: '', title: 'Mr' });
      }

      // Push the object to the array
      arrayOfObjects.push(obj);
    });

    // Return the resulting array
    return arrayOfObjects;
  }

  useEffect(() => {
    const data = createArrayOfObjects(rooms);
    setFormData({ customerDetails: data });
  }, [rooms]);

  const isValidEmail = (email) => {
    // Regular expression pattern for basic email validation
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };

  const validateForm = () => {
    let isValid = true;
    const newFormErrors = {};

    customerDetails?.forEach((noOfRooms, roomIndex) => {
      noOfRooms?.customerNames?.forEach((person, personIndex) => {
        const firstNameKey = `firstName_${roomIndex}_${personIndex}`;
        const lastNameKey = `lastName_${roomIndex}_${personIndex}`;

        if (!person.firstName.trim()) {
          newFormErrors[firstNameKey] = "Required*";
          isValid = false;
        } else if (person.firstName.length < 3) {
          newFormErrors[firstNameKey] = "Must be at least 3 characters";
          isValid = false;
        }

        if (!person.lastName.trim()) {
          newFormErrors[lastNameKey] = "Required*";
          isValid = false;
        } else if (person.lastName.length < 3) {
          newFormErrors[lastNameKey] = "Must be at least 3 characters";
          isValid = false;
        }
      });
    });

    return { isValid, errors: newFormErrors };
  };

  const handleValidation = () => {
    let isValidError = true;
    const newErrors = {};

    if (!values.name) {
      newErrors.name = "Required *";
      isValidError = false;
    } else if (values.name.length < 3) {
      newErrors.name = "Name must have at least 3 letters";
      isValidError = false;
    } else if (values.name.length > 20) {
      newErrors.name = "Name must be no longer than 20 characters.";
      isValidError = false;
    }

    if (!values.email) {
      newErrors.email = "Required *";
      isValidError = false;
    } else if (!isValidEmail(values?.email)) {
      newErrors.email = 'Please enter a valid email address.';
      isValidError = false;
    }

    if (!values.phone) {
      newErrors.phone = "Required *";
      isValidError = false;
    }
    // if (!values.specialRequest) {
    //   newErrors.specialRequest = "Required *";
    // }

    return { isValidError, newErrors };
  };


  const handleSubmitting = async (data) => {
    // e.preventDefault();

    setSubmitted(true);
    const { isValidError, newErrors } = handleValidation();
    const { isValid, errors: formErrors } = validateForm();

    const combinedErrors = { ...newErrors, ...formErrors };

    // Check if discountAmount fully covers the price (bypass payment)
    const skipPayment = discountAmount !== 0 && discountAmount !== '' && discountAmount !== undefined ? Number(discountAmount) === Number(price) : false;


    if (Object.keys(combinedErrors).length === 0 && isValidError && isValid) {

      sessionStorage.setItem("bookingQueryUrl", JSON.stringify(router.query));
      sessionStorage.setItem("bookingFormValues", JSON.stringify(values));
      // If no errors, proceed with form submission
      setIsBookNow(true);
      setBookingLoader(true);
      const userId = JSON.parse(sessionStorage.getItem("rslkey"));
      const obj = {
        userId: userId && userId !== null ? userId : "",
        fromDate: checkIn,
        returnDate: checkOut,
        staycationId: packageId,
        dayCount: nights,
        totalPrice: Number(totalPay) + Number(extraCharge) + ((Number(totalPay) + Number(extraCharge)) * vat / 100),
        discountAmount: discountAmount !== undefined ? discountAmount : 0,
        promoCode: discountAmount !== undefined ? getDetails?.promocode : "",
        //  totalPrice: getDetails?.discountAmount !== undefined ? getDetails?.discountAmount : price,
        actualAmount: price,
        currency: currency,
        // promoCode: getDetails?.discountAmount !== undefined ? getDetails?.promoCode : "",
        paymentOption: skipPayment ? 0 : data?.type,
        transRef: data?.type !== 1 ? data?.data?.pre_transaction_id : "",
        contactDetails: {
          name: values.name,
          email: values.email,
          countryCode: values.countryCode,
          mobile: values.phone,
          type: 1
        },
        isBookingFlow: isBookingFlow,
        roomCount: Number(roomCount),
        rooms: JSON.parse(additionalCounters),
        customerDetails: guestDatas
          ? guestDatas.map((room) => ({
            customerNames: room.customerNames,
          }))
          : [],
        extraPrice: Number(extraCharge),
        vat: vat == 0 ? 0 : Number(`${((Number(totalPay) + Number(extraCharge)) * vat / 100)}`),
      };
      setLoading(true);
      dispatch(staycationSaveBooking(obj));
    } else {
      setValidate(true);
      setIsBookNow(false)
      setErrors(combinedErrors)
    }
  };

  useEffect(() => {
    if (isBookingFlow === 1) {
      if (staycationBookingRes && loading) {
        setBookingLoader(false)
        setIsBookNow(false)
        if (staycationBookingRes?.status === 2) {

        } else if (staycationBookingRes?.status === -1) {

        } else if (staycationBookingRes?.status === 1) {
          sessionStorage.setItem("activityTypes", 4);
          if (staycationBookingRes?.paymentUrl !== "") {

            sessionStorage.setItem("ref", staycationBookingRes?.orderReference);
            sessionStorage.setItem("activityTypes", 4);
            router.push(staycationBookingRes?.paymentUrl);
          } else {
            sessionStorage.setItem("activityTypes", 4);
            router.push(`/loading?normal=${staycationBookingRes?.status}&statusin=${staycationBookingRes?.message}&bookingId=${staycationBookingRes?.bookingId}`);
          }

        }
        // setOpenAdd2(true);
        setLoading(false);
      }
    } else {
      if (staycationBookingRes && loading) {
        setBookingLoader(false)
        if (staycationBookingRes?.status === 2) {

        } else if (staycationBookingRes?.status === -1) {

        } else if (staycationBookingRes?.status === 1) {
          setOpenAdd2(true)
          setIsBookNow(false)
        }
        setLoading(false);
      }
    }
  }, [staycationBookingRes]);

  const handleAddClose2 = () => {
    setOpenAdd2(false);
    router.push("/staycation/staycations");
  };

  const renderStep = () => {
    const { content } = steps[currentStep];
    return <>{content}</>;
  };

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };


  useEffect(() => {
    setFormLoading(true);

    // Set a common timeout to stop formLoading after a certain delay (e.g., 2000 milliseconds or 2 seconds)
    const loadingTimeout = setTimeout(() => {
      setFormLoading(false);
    }, 2000); // Adjust the delay as needed (in milliseconds)

    return () => clearTimeout(loadingTimeout);

  }, []);

  const previousStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  useEffect(() => {
    const { discountAmount, totalPay } = calculateDiscount(price, getDetails);
    setDiscountAmount(discountAmount);
    setTotalPay(totalPay);
  }, [getDetails, price]);

  const steps = [
    {
      title: "Personal Details",
      stepNo: "1",
      stepBar: (
        <>
          <div className="col d-none d-sm-block">
            <div className="w-full h-1 bg-border"></div>
          </div>
        </>
      ),
      content: (
        <CustomerInfo
          setGuestDatas={setGuestDatas}
          bookingLoader={bookingLoader}
          setValues={setValues}
          cityName={cityName}
          packageImage={packageImage}
          packageName={packageName}
          rating={rating}
          reviews={reviews}
          values={values}
          nights={nights}
          adult={adult}
          roomCount={roomCount}
          room={room}
          child={child}
          checkIn={checkIn}
          checkOut={checkOut}
          checkInTime={checkInTime}
          checkOutTime={checkOutTime}
          handleSubmitting={handleSubmitting}
          vendorId={vendorId}
          price={price}
          discountAmount={discountAmount}
          currency={currency}
          packageId={packageId}
          setGetDetails={setGetDetails}
          getDetails={getDetails}
          setBookingLoader={setBookingLoader}
          staycationBookingRes={staycationBookingRes}
          setSearchCountryCodeValue={setSearchCountryCodeValue}
          searchCountryCodeValue={searchCountryCodeValue}
          setFormLoading={setFormLoading}
          formLoading={formLoading}
          vat={vat}
          originalPrice={originalPrice}
          extraCharge={extraCharge}
          validate={validate}
          setValidate={setValidate}
          errors={errors}
          setErrors={setErrors}
          isBookNow={isBookNow}
          setIsBookNow={setIsBookNow}
          isBookingFlow={isBookingFlow}
          setIsBookingFlow={setIsBookingFlow}
          additionalCounters={additionalCounters}
          customerDetails={customerDetails}
          submitted={submitted}
          setSubmitted={setSubmitted}
          formData={formData}
          setFormData={setFormData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
          defaultNights={defaultNights}
          defaultPrice={defaultPrice}
        />
      ),
    },
    // {
    //   title: "Payment Details",
    //   stepNo: "2",
    //   stepBar: (
    //     <>
    //       <div className="col d-none d-sm-block">
    //         <div className="w-full h-1 bg-border"></div>
    //       </div>
    //     </>
    //   ),
    //   content: <PaymentInfo />,
    // },
    // {
    //   title: "Final Step",
    //   stepNo: "3",
    //   stepBar: "",
    //   content: <OrderSubmittedInfo />,
    // },
  ];


  return (
    <>
      <Dialog
        open={openAdd2}
        TransitionComponent={Transition}
        keepMounted
        maxWidth="xl"
        onClose={handleAddClose2}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent style={{ width: "400px" }}>
          <DialogContentText id="alert-dialog-slide-description">
            <Grid container spacing={3}>
              {/* Close Icon */}
              <Grid
                item
                md={12}
                sx={{
                  position: "absolute",
                  right: 0,
                  top: -5,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <CancelIcon
                  onClick={handleAddClose2}
                  sx={{
                    color: "#6b6b6b",
                    cursor: "pointer",
                    fontSize: 26,
                  }}
                />
              </Grid>

              {/* Success Image */}
              <Grid item md={12} sx={{ display: "flex", justifyContent: "center" }}>
                <img src="/img/greenTick.png" alt="Success" width="100" />
              </Grid>

              {/* Success Message */}
              <Grid item md={12} sx={{ display: "flex", justifyContent: "center" }}>
                <Typography
                  variant="h6"
                  sx={{
                    color: "#124414",
                    fontSize: 18,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {staycationBookingRes?.message}
                </Typography>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <form onSubmit={handleSubmitting} style={{ marginTop: "10px" }}>
        <div className="row x-gap-40 y-gap-30 items-center">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <div className="col-auto">
                <div
                  className="d-flex items-center cursor-pointer transition"
                  onClick={() => setCurrentStep(index)}
                >
                  <div
                    className={
                      currentStep === index
                        ? "active size-40 rounded-full flex-center bg-dark-3"
                        : "size-40 rounded-full flex-center bg-blue-1-05 text-blue-1 fw-500"
                    }
                  >
                    {currentStep === index ? (
                      <>
                        <i className="icon-check text-16 text-white"></i>
                      </>
                    ) : (
                      <>
                        <span>{step.stepNo}</span>
                      </>
                    )}
                  </div>

                  <div className="text-18 fw-500 ml-10"> {step.title}</div>
                </div>
              </div>
              {/* End .col */}

              {step.stepBar}
            </React.Fragment>
          ))}
        </div>
        {/* End stepper header part */}

        <div className="row">{renderStep()}</div>
        {/* End main content */}

        {/* End stepper button */}
      </form>
    </>
  );
};

export default Index;
